import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PayoutsComponent} from './payouts.component';

const routes: Routes = [
    {
        path: '', component: PayoutsComponent
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/accounting/payouts/payouts.routing.ts